import {LIMIT} from "./CriteriaModel";

export interface PaginatorModel {
	pageNumber: number;
	limit: number;
	recordsCurrentPage: number;
	totalPages: number;
	totalRecords: number;
	previousPage?: number;
	nextPage?: number;
	records: any[] |  null;
}

export const EmptyPaginator: PaginatorModel = {
	pageNumber: 0,
	limit: LIMIT,
	recordsCurrentPage: 0,
	totalPages: 0,
	totalRecords: 0,
	previousPage: 0,
	nextPage: 0,
	records: [],
}
